import Vue from 'vue'
import Router from 'vue-router'
// import Cookies from "js-cookie"
import Login from '@/views/Login'
import NotFound from '@/views/Error/404'
import Home from '@/views/Home'
import Generator from '@/views/Generator/Generator'
import api from '@/http/api'
import store from '@/store'
import { getIFramePath, getIFrameUrl } from '@/utils/iframe'
import Dashboard from '@/views/Wms/Dashboard'
import TPoDetail from "../views/Wms/TPoDetail";
import TOrderDetail from "../views/Wms/TOrderDetail";
import TAfoWaveDetail from "../views/Wms/TAfoWaveDetail";
import TAfoWaveDetailLine from "../views/Wms/TAfoWaveDetailLine";
import TAfaViewWaveOrder from "../views/Wms/TAfaViewWaveOrder";
import TAfaViewWaveOrderLine from "../views/Wms/TAfaViewWaveOrderLine";
import TAllocation from "../views/Wms/TAllocation";
import TblShippingLabelDetail from "../views/Wms/TblShippingLabelDetail";
import TblInvAdjustmentDetail from "../views/Wms/TblInvAdjustmentDetail";
import TblInvMovementDetail from "../views/Wms/TblInvMovementDetail";
import ScanQrCode from "../views/Core/ScanQrCode";
import ScanCodePage from "../views/Core/ScanCodePage";
import Signature from "../views/Core/Signature";
import RfSubProcessDetail from "../views/Wms/RfSubProcessDetail";
import RfProcessResourceDetail from "../views/Wms/RfProcessResourceDetail";
import RfSubProcessOption from "../views/Wms/RfSubProcessOption";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home,
      children: [
        {
          path: '',
          name: 'PageTitle.Dashboard',
          component: Dashboard,
          meta: {
            icon: 'fa fa-tachometer fa-lg',
            index: 0
          }
        },
        {
          path: 'Wms/TPoDetail',
          name: 'PageTitle.PoDetail',
          component: TPoDetail
        },
        {
          path: 'Wms/TOrderDetail',
          name: 'PageTitle.OrderDetail',
          component: TOrderDetail
        },
        {
          path: 'Wms/TAfoWaveDetail',
          name: 'PageTitle.WaveDetail',
          component: TAfoWaveDetail
        },
        {
          path: 'Wms/TAfoWaveDetailLine',
          name: 'PageTitle.WaveDetailLine',
          component: TAfoWaveDetailLine
        },
        {
          path: 'Wms/TAfaViewWaveOrder',
          name: 'PageTitle.ViewWaveOrder',
          component: TAfaViewWaveOrder
        },
        {
          path: 'Wms/TAfaViewWaveOrderLine',
          name: 'PageTitle.ViewWaveOrderLine',
          component: TAfaViewWaveOrderLine
        },
        {
          path: 'Wms/TAllocation',
          name: 'PageTitle.Allocation',
          component: TAllocation
        },
        {
          path: 'Wms/TblShippingLabelDetail',
          name: 'PageTitle.OutboundCartonDetail',
          component: TblShippingLabelDetail
        },
        {
          path: 'Wms/TblInvAdjustmentDetail',
          name: 'PageTitle.TblInvAdjustmentDetail',
          component: TblInvAdjustmentDetail
        },
        {
          path: 'Wms/TblInvMovementDetail',
          name: 'PageTitle.TblInvMovementDetail',
          component: TblInvMovementDetail
        },
        {
          path: 'Core/ScanQrCode',
          name: 'PageTitle.ScanQrCode',
          component: ScanQrCode
        },
        {
          path: 'Core/ScanCodePage',
          name: 'PageTitle.ScanCodePage',
          component: ScanCodePage
        },
        {
          path: 'Core/Signature',
          name: 'PageTitle.Signature',
          component: Signature
        },
        {
          path: 'Wms/RfSubProcessDetail',
          name: 'PageTitle.RfSubProcessDetail',
          component: RfSubProcessDetail
        },
        {
          path: 'Wms/RfProcessResourceDetail',
          name: 'PageTitle.RfProcessResourceDetail',
          component: RfProcessResourceDetail
        },
        {
          path: 'Wms/RfSubProcessOption',
          name: 'PageTitle.RfSubProcessOption',
          component: RfSubProcessOption
        }
      ]
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 登录状态通过 sessionStorage['user'] 判断（token 存在内存中）
  let userName = sessionStorage.getItem('user')
  if (to.path === '/login') {
    // 已登录用户访问登录页 → 跳转首页
    if (userName) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (!userName) {
      // 未登录用户访问非登录页 → 重定向登录
      next({ path: '/login' })
    } else {
      // 加载动态菜单和路由
      addDynamicMenuAndRoutes(userName, to, from)
      next()
    }
  }
})

/**
* 加载动态菜单和路由
*/
function addDynamicMenuAndRoutes(userName, to, from) {
  // 处理IFrame嵌套页面
  handleIFrameUrl(to.path)
  // if(store.state.app.menuRouteLoaded) {
  //   console.log('动态菜单和路由已经存在.')
  //   return
  // }
  api.menu.findNavTree({'userName':userName})
  .then(res => {
    // 添加动态路由
    let dynamicRoutes = addDynamicRoutes(res.data)
    // 处理静态组件绑定路由
    handleStaticComponent(router, dynamicRoutes)
    router.addRoutes(router.options.routes)
    // 保存加载状态
    store.commit('menuRouteLoaded', true)
    // 保存菜单树
    store.commit('setNavTree', res.data)
  }).then(res => {
    api.user.findPermissions({'name':userName}).then(res => {
      // 保存用户权限标识集合
      store.commit('setPerms', res.data)
    })
  })
  .catch(function(res) {
  })
}

/**
 * 处理路由到本地直接指定页面组件的情况
 * 比如'代码生成'是要求直接绑定到'Generator'页面组件
 */
function handleStaticComponent(router, dynamicRoutes) {
  for(let j=0;j<dynamicRoutes.length; j++) {
    if(dynamicRoutes[j].name == '代码生成') {
      dynamicRoutes[j].component = Generator
      break
    }
  }
  router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
}

/**
 * 处理IFrame嵌套页面
 */
function handleIFrameUrl(path) {
  // 嵌套页面，保存iframeUrl到store，供IFrame组件读取展示
  let url = path
  let length = store.state.iframe.iframeUrls.length
  for(let i=0; i<length; i++) {
    let iframe = store.state.iframe.iframeUrls[i]
    if(path != null && path.endsWith(iframe.path)) {
      url = iframe.url
      store.commit('setIFrameUrl', url)
      break
    }
  }
}

/**
* 添加动态(菜单)路由
* @param {*} menuList 菜单列表
* @param {*} routes 递归创建的动态(菜单)路由
*/
function addDynamicRoutes (menuList = [], routes = []) {
 var temp = []
 for (var i = 0; i < menuList.length; i++) {
   if (menuList[i].children && menuList[i].children.length >= 1) {
     temp = temp.concat(menuList[i].children)
   } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          icon: menuList[i].icon,
          index: menuList[i].id,
          extensionReportUrl: menuList[i].extensionReportUrl
        }
      }
      let path = getIFramePath(menuList[i].url)
      if (path) {
        // 如果是嵌套页面, 通过iframe展示
        route['path'] = path
        route['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
        // 存储嵌套页面路由路径和访问URL
        let url = getIFrameUrl(menuList[i].url)
        let iFrameUrl = {'path':path, 'url':url}
        store.commit('addIFrameUrl', iFrameUrl)
      } else {
       try {
         // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
         // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
         let array = menuList[i].url.split('/')
         let url = ''
         for(let i=0; i<array.length; i++) {
            url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
         }
         url = url.substring(0, url.length - 1)
         route['component'] = resolve => require([`@/views/${url}`], resolve)
       } catch (e) {}
     }
     routes.push(route)
   }
 }
 if (temp.length >= 1) {
   addDynamicRoutes(temp, routes)
 } else {
   console.log('动态路由加载...')
   console.log(routes)
   console.log('动态路由加载完成.')
 }
 return routes
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js